/**
 * Duplicated verbatim in `packages/runtime/src/experiences/timings.ts`: this
 * package is published publicly with zero runtime dependencies and cannot
 * import a private workspace package. `__tests__/timings-parity.test.ts` asserts
 * the two copies stay in sync.
 */
export const TIMINGS = Object.freeze({
  start: 'experiences.start',
  resolve: 'experiences.resolve',
  runtimeLoad: 'experiences.runtime.load',
  configLoad: 'experiences.config.load',
  runStart: 'experiences.run.start',
  render: 'experiences.render',
});

export function mark(name: string) {
  try {
    performance.mark(name);
  } catch {
    // Instrumentation must never affect the host page.
  }
}

/**
 * Opens a measure and returns an idempotent closer, so error paths can close
 * the window from a `finally` without leaving a half-recorded entry behind.
 */
export function measure(name: string) {
  let start: number;

  try {
    start = performance.now();
  } catch {
    return () => {};
  }

  let closed = false;

  return () => {
    if (closed) {
      return;
    }
    closed = true;

    try {
      performance.measure(name, { start, end: performance.now() });
    } catch {
      // Instrumentation must never affect the host page.
    }
  };
}
